"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preferencesReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    return Object.assign({}, state, { notificationPreferences: action.notificationPreferences });
};
exports.default = preferencesReducer;
